import { ACCIONES_MAQUINA_VIRTUAL } from '@siptel-web/common';
import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';

function CambiarEstadoMaquinaVirtualModal(props) {
  const { open, close, afterConfirm } = props;
  const { fetch: sendRequest, loading } = useFetch();

  const idMaquinaVirtual = props?.data?.id;

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const cambiarEstado = React.useCallback(async () => {
    await sendRequest(`/maquinas-virtuales/${idMaquinaVirtual}`, {
      method: 'POST',
      data: { accion: props?.data?.accion },
    });

    if (typeof afterConfirm === 'function') {
      afterConfirm();
    }
    close();
  }, [sendRequest, idMaquinaVirtual, afterConfirm, props?.data?.accion, close]);

  let accion = 'Encender';

  switch (props.data.accion) {
    case ACCIONES_MAQUINA_VIRTUAL.APAGAR:
      accion = 'Apagar';
      break;
    case ACCIONES_MAQUINA_VIRTUAL.RESTABLECER:
      accion = 'Restablecer';
      break;
    case ACCIONES_MAQUINA_VIRTUAL.SUSPENDER:
      accion = 'Suspender';
      break;
    default:
      accion = 'Encender';
  }

  return (
    <Modal
      title={`${accion} Máquina Virtual: ${idMaquinaVirtual}`}
      content="¿Está seguro de querer efectuar éste cambio?"
      open={open}
      close={onCloseModal}
      onConfirm={cambiarEstado}
      isConfirming={loading}
      disabled={loading}
      confirmButtonText="Confirmar"
      cancelButtonText="Cancelar"
    />
  );
}

export default CambiarEstadoMaquinaVirtualModal;
